import product from "./product";

export default {
    product,

    noAvailableItems: "Žádné produkty nelze objednat."
}